<div
  class="module-container"
  *ngIf="{
    isVolunteer: isVolunteer$ | async,
    selectedProfile: selectedProfile$ | async
  } as obs"
>
  <gb-account-back-button></gb-account-back-button>

  <div class="flex-col px-gap-20">
    <h2 translate="CHECKOUT.HEADER"></h2>
    <p *ngIf="!obs.isVolunteer" translate="CHECKOUT.SUB_HEADER"></p>
    <p *ngIf="obs.isVolunteer" translate="CHECKOUT.SUB_HEADER_VOLUNTEER"></p>
  </div>

  <gb-select-guest
    *ngIf="obs.isVolunteer"
    [selectHeading]="'INVOICE.VOLUNTEER_SELECT_HEADING'"
    [skipProfileCheck]="true"
    [onSelectGuestActions]="onSelectGuestActions"
  >
  </gb-select-guest>

  <ng-container *ngIf="obs.selectedProfile">
    <ng-container *ngIf="!(isLoading$ | async) || (invoice$ | async)?.line_items?.length; else showLoader">
      <gb-invoice *ngIf="!(isEmptyInvoice$ | async); else emptyInvoice"></gb-invoice>
    </ng-container>

    <ng-template #emptyInvoice>
      <gb-empty-invoice></gb-empty-invoice>
    </ng-template>
  </ng-container>
  <ng-template #showLoader>
    <div class="loader-container flex-row-center">
      <gb-loading-spinner [showLoader]="isLoading$" [label]="'INVOICE.LOADING'"> </gb-loading-spinner>
    </div>
  </ng-template>
</div>
